import * as Sentry from "@sentry/react";
import { CaptureConsole } from "@sentry/integrations";

export default function initSentry() {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DNS,
    integrations: [
      new Sentry.BrowserTracing(),
      new Sentry.Replay(),
      new CaptureConsole({ levels: ["error"] })
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      process.env.REACT_APP_SENTRY_DOMAIN || "",
      process.env.REACT_APP_API_URL || ""
    ].filter(Boolean),
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}
